import TemplateContents from './TemplateContents';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();

    this.isOpen = false;
  }

  setDom() {
    super.setDom();

    this.header = document.querySelector('header');
    this.menuBtn = document.querySelector('.menuBtn');
    this.gNaviOverlay = document.querySelector('.gNaviOverlay');
    this.gNavi = document.querySelector('.gNavi');
    this.toggleItems = document.querySelectorAll('.gNavi__item.has-children');
  }

  initEvents() {
    super.initEvents();

    // Hamburger menu markup is commented out for the 9/30 launch — skip binding.
    if (!this.menuBtn) return;

    this.bindMenuBtnHandler = this.menuBtnHandler.bind(this);

    this.menuBtn.addEventListener('click', this.bindMenuBtnHandler);
    this.gNaviOverlay.addEventListener('click', (event) => {
      if (event.target === this.gNaviOverlay) this.closeHandler();
    });

    this.toggleItems.forEach((item) => {
      const toggleBtn = item.querySelector('.gNavi__toggle');
      toggleBtn.addEventListener(
        'click',
        this.toggleHandler.bind(this, item, toggleBtn)
      );
    });

    // Enable open/close transitions only after the first paint has settled,
    // so the closed state on page load doesn't visibly animate in.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.gNaviOverlay.classList.add('is-ready');
      });
    });
  }

  start() {}

  menuBtnHandler() {
    if (this.isOpen) {
      this.closeHandler();
    } else {
      this.openHandler();
    }
  }

  openHandler() {
    this.isOpen = true;
    document.documentElement.classList.add('lock');
    this.gNaviOverlay.classList.add('is-open');
    this.menuBtn.classList.add('is-open');
    this.menuBtn.setAttribute('aria-expanded', 'true');
    this.menuBtn.setAttribute('aria-label', 'メニューを閉じる');
    this.gNavi.setAttribute('aria-hidden', 'false');
  }

  closeHandler() {
    this.isOpen = false;
    document.documentElement.classList.remove('lock');
    this.gNaviOverlay.classList.remove('is-open');
    this.menuBtn.classList.remove('is-open');
    this.menuBtn.setAttribute('aria-expanded', 'false');
    this.menuBtn.setAttribute('aria-label', 'メニューを開く');
    this.gNavi.setAttribute('aria-hidden', 'true');
  }

  toggleHandler(item, toggleBtn) {
    const isCollapsed = item.classList.toggle('is-collapsed');
    toggleBtn.setAttribute('aria-expanded', String(!isCollapsed));
  }

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
